import { Injectable } from '@angular/core';
import { PortalFieldConfig, uppercaseParser } from '@portal/form/data-access';
import { FatcaModelKeys } from '../const/form-field-key.const';

@Injectable({ providedIn: 'root' })
export class FatcaFormConfigService {
  initFatcaFieldConfig(): PortalFieldConfig[] {
    return [
      {
        key: FatcaModelKeys.usPermanentResidentCardHolder,
        type: '#yesNo',
        props: {
          label: 'Are you a Resident, Green Card Holder, or Citizen of the United States of America or its territories?',
          required: true,
        },
      },
      {
        key: FatcaModelKeys.usPermanentResidentCardHolderTaxNumber,
        type: 'input',
        parsers: [uppercaseParser],
        props: {
          label: 'Tax No.',
          placeholder: 'Please enter input',
          required: true,
          minLength: 8,
          maxLength: 15,
          maskConfig: { mask: 'A*' },
        },
        expressions: { hide: '!model.usPermanentResidentCardHolder' },
      },
      {
        key: FatcaModelKeys.visa,
        type: 'input',
        props: {
          label: 'The 8 digit/letter U.S. Visa',
          required: true,
          placeholder: 'Please enter input',
          maxLength: 10,
          maskConfig: { mask: 'A*' },
        },
        expressions: { hide: '!model.usPermanentResidentCardHolder' },
      },
    ];
  }
}
